import { useState } from "react";
import { Lock, X } from "lucide-react";

export function CharlesPrivateBadge() {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 text-primary text-xs px-3 py-1">
      <Lock className="h-3 w-3" />
      Private to you
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="ml-1 opacity-70 hover:opacity-100"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
}
